<div class="mx-auto md:w-2/3 w-full flex">
  <div class="mx-auto">
  <% if notice.present? %>
    <p class="py-2 px-3 bg-green-50 mb-5 text-green-500 font-medium rounded-lg inline-block" id="notice"><%= notice %></p>
  <% end %>

  <div data-controller="info-box">
  <div class="info-button">&#x24D8;</div>
  <ul class="info-box">
  <li>Configure your event's description, options, and scoring settings on this page.</li>
  <li>Changes take effect immediately after saving.</li>
  </ul>
  </div>

  <h1 class="mx-auto font-bold text-4xl mb-4">Event Settings</h1>

  <%= form_with(model: @event) do |form| %>
  <input type="hidden" name="from_settings" value="1">

  <% if @event.errors.any? %>
    <div id="error_explanation" class="bg-red-50 text-red-500 px-3 py-2 font-medium rounded-lg mt-3 mb-5">
      <h2><%= pluralize(@event.errors.count, "error") %> prohibited these settings from being saved:</h2>
      <ul>
        <% @event.errors.each do |error| %>
          <li><%= error.full_message %></li>
        <% end %>
      </ul>
    </div>
  <% end %>

  <h2 class="font-bold text-2xl mt-6 mb-4">Description</h2>

  <div class="my-5">
    <%= form.label :name %>
    <%= form.text_field :name, class: "block shadow rounded-md border border-gray-200 outline-none px-3 py-2 mt-2 w-full" %>
  </div>

  <div class="my-5">
    <%= form.label :theme %>
    <%= form.text_field :theme, class: "block shadow rounded-md border border-gray-200 outline-none px-3 py-2 mt-2 w-full" %>
  </div>

  <div class="my-5">
    <%= form.label :location %>
    <%= form.text_area :location, rows: 3,
      class: "block shadow rounded-md border border-gray-200 outline-none px-3 py-2 mt-2 w-full" %>
  </div>

  <div class="my-5">
    <%= form.label :date, 'Date(s)' %>
    <%= form.text_field :date, class: "block shadow rounded-md border border-gray-200 outline-none px-3 py-2 mt-2 w-full" %>
  </div>

  <div class="my-5">
    <%= form.label :heat_length, 'Seconds between heats' %>
    <%= form.number_field :heat_length, min: 46, class: "block shadow rounded-md border border-gray-200 outline-none px-3 py-2 mt-2 w-full" %>
  </div>

  <div class="my-5">
    <%= form.label :solo_length, 'Seconds between solos' %>
    <%= form.number_field :solo_length, min: 46, class: "block shadow rounded-md border border-gray-200 outline-none px-3 py-2 mt-2 w-full" %>
  </div>

  <div class="my-5">
    <%= form.label :counter_color, 'Counter color' %>
    <%= form.color_field :counter_color, class: "block shadow rounded-md border border-gray-200 outline-none px-3 py-2 mt-2 w-full" %>
  </div>

  <h2 class="font-bold text-2xl mt-8 mb-4">Options</h2>

  <div class="my-5">
    <%= form.label :column_order, 'Heat list column order' %>
    <ul class="ml-6">
      <li class="my-2"><label><%= form.radio_button :column_order, 1 %> Lead, Follow</label></li>
      <li class="my-2"><label><%= form.radio_button :column_order, 2 %> Student, Instructor</label></li>
    </ul>
  </div>

  <div class="my-5">
    <%= form.label :ballrooms %>
    <ul class="ml-6">
      <li class="my-2"><label><%= form.radio_button :ballrooms, 1 %> One ballroom</label></li>
      <li class="my-2"><label><%= form.radio_button :ballrooms, 2 %> Two ballrooms (split)</label></li>
      <li class="my-2"><label><%= form.radio_button :ballrooms, 3 %> Two ballrooms (rotating)</label></li>
    </ul>
  </div>

  <div class="my-5">
    <%= form.label :heat_order %>
    <ul class="ml-6">
      <li class="my-2"><label><%= form.radio_button :heat_order, 'L' %> Newcomer to Advanced</label></li>
      <li class="my-2"><label><%= form.radio_button :heat_order, 'R' %> Random</label></li>
    </ul>
  </div>

  <div class="my-5 flex items-center">
    <%= form.check_box :intermix %> &nbsp;
    <%= form.label :intermix, 'Intermix dances within category?' %>
  </div>

  <div class="my-5 flex items-center">
    <%= form.check_box :backnums %> &nbsp;
    <%= form.label :backnums, 'Use back numbers?' %>
  </div>

  <div class="my-5 flex items-center">
    <%= form.check_box :track_ages %> &nbsp;
    <%= form.label :track_ages, 'Track student ages?' %>
  </div>

  <div class="my-5 flex items-center">
    <%= form.check_box :include_open %> &nbsp;
    <%= form.label :include_open, 'Include open freestyles?' %>
  </div>

  <div class="my-5 flex items-center">
    <%= form.check_box :include_closed %> &nbsp;
    <%= form.label :include_closed, 'Include closed freestyles?' %>
  </div>

  <div class="my-5 flex items-center">
    <%= form.check_box :pro_heats %> &nbsp;
    <%= form.label :pro_heats, 'Include pro heats?' %>
  </div>

  <div class="my-5 flex items-center">
    <%= form.check_box :agenda_based_entries %> &nbsp;
    <%= form.label :agenda_based_entries, 'Match entry forms to agenda?' %>
  </div>

  <h2 class="font-bold text-2xl mt-8 mb-4">Scoring</h2>

  <div class="my-5">
    <%= form.label :open_scoring %>
    <ul class="ml-6">
      <li class="my-2"><label><%= form.radio_button :open_scoring, '1' %> 1/2/3/F</label></li>
      <li class="my-2"><label><%= form.radio_button :open_scoring, 'G' %> GH/G/S/B</label></li>
      <li class="my-2"><label><%= form.radio_button :open_scoring, '#' %> Number (85, 95, ...)</label></li>
      <li class="my-2"><label><%= form.radio_button :open_scoring, '0' %> None</label></li>
    </ul>
  </div>

  <div class="my-5">
    <%= form.label :multi_scoring %>
    <ul class="ml-6">
      <li class="my-2"><label><%= form.radio_button :multi_scoring, '1' %> 1/2/3/F</label></li>
      <li class="my-2"><label><%= form.radio_button :multi_scoring, 'G' %> GH/G/S/B</label></li>
      <li class="my-2"><label><%= form.radio_button :multi_scoring, '#' %> Number</label></li>
    </ul>
  </div>

  <div class="my-5 flex items-center">
    <%= form.check_box :judge_comments %> &nbsp;
    <%= form.label :judge_comments, 'Enable judge comments?' %>
  </div>

  <div class="my-5">
    <%= form.label :max_heat_size, 'Maximum heat size' %>
    <%= form.number_field :max_heat_size, min: 1, class: "block shadow rounded-md border border-gray-200 outline-none px-3 py-2 mt-2 w-full" %>
  </div>

  <div class="my-5">
    <%= form.label :dance_limit, 'Limit entries per dance' %>
    <%= form.number_field :dance_limit, min: 0, class: "block shadow rounded-md border border-gray-200 outline-none px-3 py-2 mt-2 w-full" %>
  </div>

  <div class="mt-6 flex justify-between items-center">
    <%= form.submit 'Save Settings', class: "btn-blue" %>
    <%= link_to 'Back to Event', root_path, class: "btn-green" %>
  </div>
  <% end %>
  </div>
</div>
